import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";

class DeleteAccount extends Component {
    constructor() {
        super();
        this.state = {
        }
    };


    render() {
        return (
            <div className="wrapper">
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />

                <ToastContainer className="Toast-at-center" />

                <div className="card-body p-0" style={{ maxWidth: "800px",
            textAlign: "left", margin:"auto", color: "#333" }}>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <div className="card sign-in-right-tab">
                                <div className="card-body" style={{ padding: "10px" }}>
                                    <div className="col-sm-12">
                                        <div className="logoBox mb-2">
                                            <img src="./assets/images/jeeva-logo.svg" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-9 p-0 mx-auto ">
                                        <h1 className="signinTitle" style={{color:"#333"}}>Deleting your MyJEEVA Account
                                            </h1>
                                        <div>
                                            <p>
                                                It's a good cyber hygiene habit to occasionally delete your unused accounts. 🔒 Doing so reduces the risk of cyberattacks and keeps your data safe from prying eyes. 💡 Whether you want to protect your personal information or take control of your spending habits, permanently deleting your MyJEEVA account can be done in just a few minutes. 💻🔧 Read the instructions below to find out how.
                                            </p>
                                        </div>
                                        <div>
                                            <h2>Contents</h2><br />
                                            <h5>
                                                1.How to delete your Account from MyJEEVA application 🗑️
                                            </h5>  
                                            <h5>
                                                2.How to logout from MyJEEVA application 🔓
                                            </h5>
                                            <h5>
                                                3.How to Opt-Out from the Enrolled Treatments 🚫
                                            </h5>
                                              
                                        </div>
                                        <br />
                                        <div>
                                            <h2>1.How to delete your account from MyJEEVA application.
                                            </h2><br />
                                            <h5>Read on to learn how to delete your account from MyJEEVA application.</h5>
                                            <br />
                                            <p>Deleting 🗑️ your MyJEEVA application account from your phone is pretty simple. </p>
                                            <p>Click on your profile image <img style={{height:"2em"}} src="./assets/images/account-button.png" alt="" /> from the MyJEEVA application.
                                            </p>
                                            <p>The App loads the page with your profile details. Find and click on the delete account button as highlighted in the image below.👇
                                            </p>
                                            <br /> 
                                            <img
                                                className="delete-responsive"
                                                src="./assets/images/delete_account.jpg"
                                                style={{ marginLeft: "calc(50% - 140px)", borderRadius:"37px" }}
                                            />
                                        </div>
                                        <br />
                                        <div>
                                            <h2>2.How to logout from MyJEEVA application
                                            </h2><br />
                                            <h5>Read on to learn how to logout from your MyJEEVA account🔓</h5>
                                            <br />
                                            <p>Click on your profile image <img style={{height:"2em"}} src="./assets/images/account-button.png" alt="" /> from the MyJEEVA application
                                            </p>
                                            <p>The App loads the page with your profile details. Find and click on the logout button as highlighted in the image below.👇
                                            </p>
                                            <br />
                                            
                                            <img
                                                className="delete-responsive"
                                                src="./assets/images/logout_new.jpg"
                                                style={{ marginLeft: "calc(50% - 140px)", borderRadius:"37px" }}
                                            />
                                        </div>
                                        <br />
                                        <div>
                                            <h2 >3.How to Opt-Out from the enrolled treatments.
                                            </h2><br />
                                            <h5>Read on to learn how to Opt-Out from Enrolled Treatments.</h5>
                                            <br />
                                            <p>Page with your profile details appear and find and click on the Treatment tab.
                                            </p>
                                            <p>List of enrolled treatments are visible and click on Opt-Out button.
                                            </p>
                                            <br />
                                            <p>Follow the same procedure to opt-out from all the treatments.
                                            </p>
                                            <br />
                                            <img
                                                className="delete-responsive"
                                                src="./assets/images/optout_new.jpg"
                                                style={{ marginLeft: "calc(50% - 140px)", borderRadius:"37px" }}
                                            />
                                        </div>
                                        <br />
                                        <p>Follow the same procedure to opt-out from all the treatments.
                                            </p>
                                        <br />
                                        {/* <div>
                                            <h2>3.How to delete your account from MyJEEVA application.
                                            </h2><br />
                                            <p>Deleting 🗑️ your other accounts connected to MyJEEVA application from your phone is pretty simple. Please write an email to us at <a href="mailto:system@myjeeva.net" target="_blank" rel="noopener noreferrer">system@myjeeva.net</a>.
                                            </p>
                                            <p>We shall delete your account and any data associated with your account in 5 working days.
                                                You will be notified of the same by the MyJEEVA Team.
                                            </p>
                                            <br />
                                        </div>
                                        <br /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default DeleteAccount;



// WEBPACK FOOTER //
// src/my-jeeva/DeleteAccount.js